import { withInstall } from '@/utils'
import UploadFile from './src/uploadFile.vue'
export default withInstall(UploadFile)
